<section class="business-registration-ads-detail-list">
  <div class="box">
    <div class="box-content mobile">
      <div class="box-content__detail">
        <div class="box-content__detail--text"
          ><span
            >{{ 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.SERVICE.TEXT' | translate }}<br />{{
              'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.SERVICE.TEXT_2' | translate
            }}</span
          >
        </div>
        <div class="box-content__detail--price"
          ><span class="price-blue">9,990.-</span>
          <div class="price-normal"
            ><span>{{ 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.SERVICE.PRICE_NORMAL' | translate }}</span>
            <del> 22,990.</del>-
          </div>
        </div>
      </div>
    </div>
    <div class="box-wrapper">
      <ng-container *ngFor="let item of mockContent">
        <div class="box-wrapper__content">
          <div class="box-wrapper__content__heading">{{ item.title | translate }}</div>
          <ul class="box-wrapper__content__text">
            <span [innerHTML]="item.detail | translate"></span>
          </ul>
        </div>
      </ng-container>
    </div>
    <div class="box-content desktop">
      <div class="box-content__detail">
        <div class="box-content__detail--text"
          ><span
            >{{ 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.SERVICE.TEXT' | translate }}<br />{{
              'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.SERVICE.TEXT_2' | translate
            }}</span
          >
        </div>
        <div class="box-content__detail--price"
          ><span class="price-blue">9,990.-</span>
          <div class="price-normal"
            ><span>{{ 'BUSINESS_REGISTRATION_ADS.DETAIL_LIST.SERVICE.PRICE_NORMAL' | translate }}</span>
            <del> 22,990.</del>-
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
